
import {Component} from 'vue-property-decorator';
import {mixins} from 'vue-class-component';
import SnackbarMixin from '@/mixins/SnackbarMixin';
import LoadingMixin from '@/mixins/LoadingMixin';
import {swalSuccess, swalError} from '@/plugins/swal';

@Component
export default class FormEducation extends mixins(LoadingMixin, SnackbarMixin) {
  getColor(status: number) {
    return status === 1 ? 'success' : 'error';
  }
  showAddFrom = false;
  form = {
    category: null,
    hard_skill: [],
    soft_skill: [],
  };
  isEdit = true;
  hard_skill_list = [];
  soft_skill_list = [];
  listCategories = [];
  profileEdit = false;
  isLoading = false;
  hardSkill: any = [];
  softSkill: any = [];
  get rules() {
    return {
      category: '',
      hard_skill: '',
      soft_skill: '',
    };
  }
  async mounted() {
    this.getCategories();
    this.getSoftskill();
    this.getDetailSkill();
  }

  async onSubmit() {
    try {
      this.startLoading('saving');
      if (this.form.hard_skill) {
        this.hardSkill = this.form.hard_skill.map((item: any) => {
          return {
            category: this.form.category,
            id: item,
          };
        });
      }
      if (this.form.soft_skill) {
        this.softSkill = this.form.soft_skill.map((item: any) => {
          return {
            id: item,
          };
        });
      }
      if (!this.isEdit) {
        const res = await this.$store.dispatch('skill/createSkill', {
          hard_skill: this.hardSkill,
          soft_skill: this.softSkill,
        });

        if (res.status === 200) {
          this.finishLoading('saving');
          swalSuccess.fire({
            title: 'Success!',
            text: res.data.message,
          });
          this.getDetailSkill();
          this.$router.push('/quiz/introduction');
        }
      } else {
        const res = await this.$store.dispatch('skill/updateSkill', {
          hard_skill: this.hardSkill,
          soft_skill: this.softSkill,
        });

        if (res.status === 200) {
          this.finishLoading('saving');
          swalSuccess.fire({
            title: 'Success!',
            text: res.data.message,
          });
          this.getDetailSkill();
          this.$router.push('/quiz/introduction');
        }
      }
    } catch (e) {
      swalError.fire({
        title: 'Failed!',
        text:
          e.response?.error?.message ||
          'Sebuah kesalahan yang tidak diduga telah terjadi.',
      });
    }
  }
  async getCategories() {
    try {
      this.startLoading('detail');
      const {data} = await this.$store.dispatch('skill/getCategory');
      this.finishLoading('detail');

      this.listCategories = data;
      this.isLoading = false;
    } catch (e) {
      this.isLoading = false;
      this.catchError(e);
    }
  }
  async getSoftskill() {
    try {
      this.startLoading('detail');
      const {data} = await this.$store.dispatch('skill/getSoftSkill');
      this.finishLoading('detail');

      this.soft_skill_list = data;
      this.isLoading = false;
    } catch (e) {
      this.isLoading = false;
      this.catchError(e);
    }
  }
  async getHardSkill() {
    try {
      this.startLoading('detail');
      const {data} = await this.$store.dispatch('skill/getHardSkill', {
        category: this.form.category,
      });
      this.finishLoading('detail');

      this.hard_skill_list = data;
      this.isLoading = false;
    } catch (e) {
      this.isLoading = false;
      this.catchError(e);
    }
  }
  async getDetailSkill() {
    try {
      this.startLoading('detail');
      const {data} = await this.$store.dispatch('skill/getDetailSkill');
      this.finishLoading('detail');
      if (data) {
        this.form.category = data.hard_skill[0].category;
        this.getHardSkill();

        this.form.hard_skill = data.hard_skill.map((obj: any) => {
          return obj.id.toString();
        });
        this.form.soft_skill = data.soft_skill.map((obj: any) => {
          return obj.id;
        });
      } else {
        this.isEdit = false;
      }
      this.isLoading = false;
    } catch (e) {
      this.isLoading = false;
      this.catchError(e);
    }
  }
}
